module.exports = __webpack_public_path__ + "static/img/title_en.a1e5c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/loader/img/title_en.png
// module id = vtPM
// module chunks = 0